import { render, staticRenderFns } from "./ItemDepartmentA.vue?vue&type=template&id=303690d1&scoped=true&"
import script from "./ItemDepartmentA.vue?vue&type=script&lang=js&"
export * from "./ItemDepartmentA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303690d1",
  null
  
)

export default component.exports